import { render, staticRenderFns } from "./solvent.vue?vue&type=template&id=5b751877&"
import script from "./solvent.vue?vue&type=script&lang=js&"
export * from "./solvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b751877')) {
      api.createRecord('5b751877', component.options)
    } else {
      api.reload('5b751877', component.options)
    }
    module.hot.accept("./solvent.vue?vue&type=template&id=5b751877&", function () {
      api.rerender('5b751877', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/data-dictionary/solvent/solvent.vue"
export default component.exports